import React, { Component } from 'react';

import { SINGLE_MODE, MULTI_MODE, SECONDARY_MODE, COURIER_RFQ_TYPE, EXIM_RFQ_TYPE, AWL_MULTI_MODE, RIL_WAREHOUSE, GENERAL_PROCUREMENT, DISPOSAL_PRODUCT, CONTAINER_RFQ } from 'Constants/commonConstants';

import {
   SERVICE_TYPES,
   SERVICE_MODES,
   INSURANCE_BY
} from 'Constants/commonConstants';

import ClassNames from 'classnames';
import ClickOutside from 'Components/ClickOutside';

// import SingleModeImage from 'Icons/rfqSingleMode.png'
// import MultiModeImage from 'Icons/rfqMultiMode.png'
import SingleModeImage from 'Icons/SingleModeFTL.jpg';
import MultiModeImage from 'Icons/MultiMode.jpg';
import DedicatedAndFixedImage from 'Icons/DedicatedAndFixed.jpg';
import courierImage from 'Icons/courier.jpg';
import EximImage from 'Icons/Exim.jpg';

import { ReactComponent as FTLIcon } from 'Icons/ftl-road.svg'
import { ReactComponent as LCLIcon } from 'Icons/lcl-express.svg'
import { ReactComponent as CourierIcon } from 'Icons/courier.svg'
import { ReactComponent as ContainerIcon } from 'Icons/container.svg'
import { ReactComponent as BulkIcon } from 'Icons/bulk.svg'
import { getUser } from 'Utils/storage';
import { ReactComponent as DropdownIcon } from 'Icons/download.svg';

const singleModeHeader = "Single Mode RFQ";
const multiModeHeader = "Multi-Modal RFQ";
const secondaryModeHeader = "Dedicated & Fix Mode RFQ";
const courierHeader = "Courier RFQ";
const eximHeader = "EXIM RFQ";
const awlMultiModeHeader = "Multi-Modal RFQ";
const disposalProductHeader = "Disposal Product RFQ";
const containerHeader = "Container RFQ";
const generalProcurementHeader = "General Procurement RFQ";

const singleModeCaption = "Create A Single Mode RFQ For Rail, Coastal Or Road In Quick Easy Steps.";
const multiModeCaption = "Select Multiple Transpot Modes And Create A Multi-modal RFQ In Quick Easy Steps.";
const secondaryModeCaption = "Create A Dedicated And Fix Mode RFQ For Rail, Coastal Or Road In Quick Easy Steps.";
const courierCaption = "Create A Courier RFQ For Surface or Air In Quick Easy Steps.";
const eximCaption = "Create A EXIM RFQ In Quick Easy Steps.";
const rilWarehouseCaption = "Create A 3PL Services RFQ In Quick Easy Steps.";
const generalProcurementCaption = "Create A General Procurement RFQ In Quick Easy Steps.";
const disposalProductCaption = "Create A Disposal Product RFQ In Quick Easy Steps.";
const conatinerCaption = "Create A Container RFQ In Quick Easy Steps.";

const singleModeButton = "Create New Single Mode RFQ";
const multiModeButton = "Create New Multi-Modal Mode RFQ";
const secondaryModeButton = "Create New Dedicated & Fix Mode RFQ";
const courierButton = "Create New Courier RFQ";
const eximButton = "Create New EXIM RFQ";
const awlMultiModeButton = "Create New Multi-Modal Mode RFQ";
const disposalProductButton = "Create New Disposal Product RFQ";
const containerButton = "Create New Container RFQ";
const generalProcurementButton = "Create New General Procurement RFQ";

export default class RFQCard extends Component {
   state = {
      isServiceTypePopupShown: false,
      serviceType: 0
   }
   downloadRFQTemplate = () => {
      const { type } = this.props;
      this.props.downloadRFQTemplate({
         rfqType: type,
         serviceType: (type === 1 || type === 4) ? this.state.serviceType : undefined
      });
   }
   showServiceTypePopup = () => {
      this.setState({
         isServiceTypePopupShown: true
      })
   }
   hideServiceTypePopup = () => {
      this.setState({
         isServiceTypePopupShown: false
      })
   }
   toggleServiceType = (e) => {
      const serviceType = parseInt(e.currentTarget.getAttribute('name'));
      this.setState({
         serviceType
      }, () => {
         this.hideServiceTypePopup();
         this.downloadRFQTemplate();
      });
   }
   serviceTypesFormat = () => {
      return (
         <ClickOutside handleClickOutside={this.hideServiceTypePopup}>
            <div className="pa flex bg-white box-shadow b-30 hCenter triangle-bottom">
               {
                  SERVICE_TYPES.map((serviceType, index) => {
                     return (
                        <div
                           className={ClassNames("border-white tCenter wt-100 ml-10 mr-10 pt-10 pb-10", {
                              'box-shadow select-icon border-theme br-5': this.state.serviceType === serviceType.value
                           })}
                           key={serviceType.value}
                           name={serviceType.value}
                           index={index}
                           onClick={this.toggleServiceType}
                        >
                           {serviceType.value === 1 && <FTLIcon />}
                           {serviceType.value === 2 && <LCLIcon />}
                           {serviceType.value === 3 && <CourierIcon />}
                           {serviceType.value === 4 && <ContainerIcon />}
                           {/* {serviceType.value ===5 && <BulkIcon />} */}
                           <div className={ClassNames("mt-10 fs-16 fBold tCenter", {
                              'theme-color ': this.state.serviceType === serviceType.value,
                              'label-color ': !(this.state.serviceType === serviceType.value)
                           })}>{serviceType.name}</div>
                        </div>
                     )
                  })
               }
            </div>
         </ClickOutside>
      )
   }
   uploadRFQ = (e) => {
      const { type, uploadRFQ } = this.props;
      uploadRFQ(this.input.files[0], {
         type
      });
   }

   getTypeDetails = (type) => {
      let details = {
         header: '',
         caption: '',
         buttonName: '',
         rfqImage: ''
      };
      if(type === SINGLE_MODE) {
         details.header = singleModeHeader;
         details.caption = singleModeCaption;
         details.buttonName = singleModeButton;
         details.rfqImage = SingleModeImage;
      } else if(type === MULTI_MODE) {
         details.header = multiModeHeader;
         details.caption = multiModeCaption;
         details.buttonName = multiModeButton;
         details.rfqImage = MultiModeImage;
      } else if(type === SECONDARY_MODE) {
         details.header = secondaryModeHeader;
         details.caption = secondaryModeCaption;
         details.buttonName = secondaryModeButton;
         details.rfqImage = DedicatedAndFixedImage;
      } else if(type === COURIER_RFQ_TYPE) {
         details.header = courierHeader;
         details.caption = courierCaption;
         details.buttonName = courierButton;
         details.rfqImage = courierImage;
      } else if(type === EXIM_RFQ_TYPE) {
         details.header = eximHeader;
         details.caption = eximCaption;
         details.buttonName = eximButton;
         details.rfqImage = EximImage;
      } else if(type === AWL_MULTI_MODE) {
         details.header = awlMultiModeHeader;
         details.caption = multiModeCaption;
         details.buttonName = awlMultiModeButton;
         details.rfqImage = MultiModeImage;
      } else if(type === DISPOSAL_PRODUCT) {
         details.header = disposalProductHeader;
         details.caption = disposalProductCaption;
         details.buttonName = disposalProductButton;
         details.rfqImage = SingleModeImage;
      } else if(type === CONTAINER_RFQ) {
         details.header = containerHeader;
         details.caption = conatinerCaption;
         details.buttonName = containerButton;
         details.rfqImage = DedicatedAndFixedImage;
      } else if(type === GENERAL_PROCUREMENT) {
         details.header = generalProcurementHeader;
         details.caption = generalProcurementCaption;
         details.buttonName = generalProcurementButton;
         details.rfqImage = SingleModeImage;
      }
      return details;
   }


   render() {
      const { type, createRFQ } = this.props;
      return (
         <div className="wt-300 rfq-card box-shadow ph-20 pv-20 flex flex-column flex-middle br-5 mr-5 ml-10">
            <img alt="" src={this.getTypeDetails(type).rfqImage} className="ht-250 wt-250 mb-30" />
            <div className="fBold fs-22 mb-15 tCenter ht-40">{this.getTypeDetails(type).header}</div>
            <div className="fSemibold fs-14 mb-30 tCenter ht-40">{this.getTypeDetails(type).caption}</div>
            <button onClick={createRFQ} className="bg-theme wt-270 mb-10 ht-40 br-20 fBold fs-14 white-color">{this.getTypeDetails(type).buttonName}</button>
            {/* <label htmlFor={"UPLOAD" + type} className="curP flex flex-middle flex-center bg-white wt-300 mb-20 ht-40 br-20 border-theme fBold fs-16 theme-color mb-20">Upload Excel</label> */}
            {/* <div className="pr curP flex flex-middle fBold fs-14 theme-color" onClick={type === 1?this.showServiceTypePopup:this.downloadRFQTemplate}>
                    <DropdownIcon /> 
                    <span className="pl-10">Download Excel</span>
                    {type === 1 && this.state.isServiceTypePopupShown && this.serviceTypesFormat()}
                </div> */}
            <input type="file" ref={(ref) => { this.input = ref; }} id={"UPLOAD" + type} onChange={this.uploadRFQ} className="dNone" />
         </div>
      )
   }
}